import { SocialMediaType } from '../types/socialMedia';

/**
 * Map of uppercase social media platform keys to their display values.
 * Used for consistent social media type lookups across the application.
 */
export const SOCIAL_MEDIA_TYPES: Record<string, SocialMediaType> = Object.freeze({
  INSTAGRAM: 'instagram',
  YOUTUBE: 'youtube',
  SOUNDCLOUD: 'soundcloud',
  TWITTER: 'twitter',
  X: 'x',
  FACEBOOK: 'facebook',
  SPOTIFY: 'spotify',
} as const);
